import { Button, message, Tooltip } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { useFlowbackStore } from '@/store/flowbackStore';
import { registerFlowback } from '@/api/requirementFlowback';

interface FlowbackButtonProps {
  projectId: number;
  requirementId: string;
  subcategory: string;
  onRegistered?: () => void;
}

/** "回流主线" button — only visible to internal users (external users cannot trigger flowback). */
const FlowbackButton: React.FC<FlowbackButtonProps> = ({
  projectId,
  requirementId,
  subcategory,
  onRegistered,
}) => {
  const user = useAuthStore((s) => s.user);
  const eligible = useFlowbackStore((s) => s.eligibilitySet.has(requirementId));
  const [loading, setLoading] = useState(false);

  if (!user || user.user_type !== 'internal') {
    return null;
  }

  const handleClick = async () => {
    setLoading(true);
    try {
      await registerFlowback({ project_id: projectId, requirement_id: requirementId, subcategory });
      message.success('已登记需求回流，等待 mainline 评审');
      onRegistered?.();
    } catch (error: unknown) {
      const err = error as { response?: { data?: { detail?: string; code?: string } } };
      const detail = err?.response?.data?.detail || '登记失败';
      message.error(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title={eligible ? '将本项目需求回流至主线（经 mainline 评审合入）' : '需求无需回流：版本不高于主线或主线已是最新'}>
      <Button
        type="text"
        size="small"
        icon={<ThunderboltOutlined />}
        loading={loading}
        disabled={!eligible}
        onClick={handleClick}
      >
        回流主线
      </Button>
    </Tooltip>
  );
};

export default FlowbackButton;
